var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_20006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6693 5.95833L16.9609 3.20833L17.4193 2.75V3.20833V13.75H12.8359V11.9167L13.2943 8.70833L14.6693 5.95833Z",
    fill: "#C8CEDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4154 13.75V2.75C13.0007 6.96117 12.8109 10.3758 12.832 13.75H17.4154ZM17.4154 13.75V19.25H16.4987V16.5M7.33203 3.66667V19.25M4.58203 3.66667V6.41667C4.58203 7.14601 4.87176 7.84549 5.38749 8.36121C5.90321 8.87694 6.60269 9.16667 7.33203 9.16667C8.06138 9.16667 8.76085 8.87694 9.27658 8.36121C9.7923 7.84549 10.082 7.14601 10.082 6.41667V3.66667",
    stroke: "#798399",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_20006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDinner);
export default __webpack_public_path__ + "static/media/icon-dinner.8e7dd937010f969d28ea2702d2b64698.svg";
export { ForwardRef as ReactComponent };